import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { parseJwt } from "../utils/custom";

const PrivateRoute = (props) => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const router = useLocation();
  const { children } = props;
  const isLoggedIn = localStorage.getItem("token") ? true : false;

  useEffect(() => {
    if (token) {
      const decodedJwt = parseJwt(token);
      if (!decodedJwt || !decodedJwt.exp || decodedJwt.exp * 1000 < Date.now()) {
        localStorage.clear();
        navigate("/");
      } else {
        if (router.pathname === "/session") {
          navigate("/session");
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return isLoggedIn ? <>{children}</> : <Navigate replace={true} to="/" />;
};

export default PrivateRoute;
